import { createContext, useContext, useEffect, useState, useCallback } from 'react';
import { api } from '../lib/api';

const AuthCtx = createContext(null);
export const useAuth = () => useContext(AuthCtx);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null); // null=checking, false=logged out, object=logged in

  useEffect(() => {
    api.get('/auth/me').then((r) => setUser(r.data)).catch(() => setUser(false));
  }, []);

  const login = useCallback(async (email, password) => {
    const { data } = await api.post('/auth/login', { email, password });
    if (data.mfa_required) return { mfaToken: data.mfa_token };
    setUser(data.user); // session lives in httpOnly cookies set by the backend
    return { user: data.user };
  }, []);

  const verifyMfa = useCallback(async (mfaToken, code) => {
    const { data } = await api.post('/auth/mfa/verify', { mfa_token: mfaToken, code });
    setUser(data.user);
  }, []);

  const logout = useCallback(async () => {
    try { await api.post('/auth/logout'); } catch (e) { /* ignore */ }
    localStorage.removeItem('or_token'); // purge legacy tokens from older sessions
    setUser(false);
  }, []);

  return <AuthCtx.Provider value={{ user, login, verifyMfa, logout }}>{children}</AuthCtx.Provider>;
}
